import React from "react";
import styles from "./styles";
import Title from "../../ui/title";
import Back from "../../ui/back";
import { withStyles } from "material-ui/styles";
import { withRouter } from "react-router-dom";
import TextField from "material-ui/TextField";
import { FormControlLabel } from "material-ui/Form";
import Checkbox from "material-ui/Checkbox";
import Content from "../../ui/content";
import Grid from "material-ui/Grid";
import Button from "material-ui/Button";
import { validateFormData } from "../../../common/formtool";
import BackCheck from "../../ui/backCheck";
import ConfirmDialog from "../../common/dialog/confirm";
import Typography from "material-ui/Typography";
import { ToInt } from "../../../common/datatypetool";
import Icon from "material-ui/Icon";

class PoELoad extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isChanged: false,
      customerPoELoad: null,
      defaultPowerlimit: "",
      poeErrors: {},
      showConfirmBack: false,
      isRestore: false,
      showRestoreConfirm: false,
      isPoeLoadUpdated: false,
    };
  }

  onCheckboxChange = (e) => {
    let customerPoELoad = { ...this.state.customerPoELoad };
    const { translate } = this.props;
    if (e.target.name === "poestandard") {
      customerPoELoad.poestd = !customerPoELoad.poestd;
    }
    let poeErrors = { ...this.state.poeErrors };
    if (customerPoELoad.poestd) {
      const powerlimit = customerPoELoad.powerlimit;
      poeErrors = {};
      let validationObj = {
        powerlimit: {
          required: translate("formfield_error_general_required"),
          range: {
            minValue: 0,
            maxValue: 90,
            message: translate("sub_test_ping_validation_range", {
              name: translate("subtest_poeload_powerlimit"),
              value1: 0,
              value2: 90,
            }),
          },
        },
      };
      let errors = validateFormData({ powerlimit }, validationObj);
      if (Object.keys(errors).length) {
        customerPoELoad.powerlimit = this.state.defaultPowerlimit;
      }
    }
    this.setState({
      customerPoELoad,
      isChanged: true,
      poeErrors,
      isRestore: false,
    });
  };

  onTextEdit = (e) => {
    let poeErrors = { ...this.state.poeErrors };
    poeErrors = {
      ...poeErrors,
      [e.target.name]: false,
    };
    let customerPoELoad = { ...this.state.customerPoELoad };
    if (e.target.name === "powerlimit") {
      customerPoELoad.powerlimit = ToInt(e.target.value);
    }
    this.setState({
      customerPoELoad,
      isChanged: true,
      isRestore: false,
      poeErrors,
    });
  };

  onPoELoadSave = () => {
    let { translate, isTestEdit } = this.props;
    this.setState(
      {
        isChanged: true,
      },
      () => {
        let vobj = {
          powerlimit: {
            required: translate("formfield_error_general_required"),
            range: {
              minValue: 0,
              maxValue: 90,
              message: translate("sub_test_ping_validation_range", {
                name: translate("subtest_poeload_powerlimit"),
                value1: 0,
                value2: 90,
              }),
            },
          },
        };
        let poeErrors = validateFormData(this.state.customerPoELoad, vobj);
        const missingFieldName = Object.keys(poeErrors)[0];
        if (missingFieldName) {
          const textField = document.getElementsByName(missingFieldName)[0];
          textField && textField.focus();
        }
        if (Object.keys(poeErrors).length) {
          this.setState({ poeErrors: poeErrors });
        } else {
          if (isTestEdit) {
            this.props.updateCustPoELoad(
              this.props.selectedTest,
              this.state.customerPoELoad
            );
            this.props.handleClose();
            if (this.state.isRestore) {
              this.props.deleteDefaultSubtests(this.props.selectedTest);
            }
          } else {
            this.props.updateCustPoELoad(this.state.customerPoELoad);
          }
        }

        this.setState({
          isChanged: false,
        });
      }
    );
  };

  onBackClick = () => {
    if (this.state.isChanged) {
      this.setState({
        showConfirmBack: true,
      });
    }
  };
  onBackYesClick = () => {
    this.onPoELoadSave();
    this.setState({
      showConfirmBack: false,
    });
  };
  onBackNoClick = () => {
    this.props.history.push("/subtestsettings");
  };
  hideBackConfirmModal = () => {
    this.setState({
      showConfirmBack: false,
    });
  };

  onResetDetails = () => {
    this.setState({
      showRestoreConfirm: true,
    });
  };

  onRestoreConfirm = () => {
    // this.props.updateCustPoELoad(this.props.selectedTest, this.props.customerPoELoad);
    this.setState({
      customerPoELoad: this.props.customerPoELoad,
      showRestoreConfirm: false,
      isChanged: true,
      isRestore: true,
    });
  };

  hideRestoreConfirmModal = () => {
    this.setState({
      showRestoreConfirm: false,
    });
  };

  componentWillMount() {
    this.props.getCustPoELoad();
  }

  componentWillReceiveProps(nextProps) {
    const { customerPoELoad, poeLoadDetails, isTestEdit } = nextProps;
    if (isTestEdit) {
      if (
        (poeLoadDetails && !this.state.isPoeLoadUpdated) ||
        (poeLoadDetails && this.props.poeLoadDetails !== poeLoadDetails)
      ) {
        this.setState({
          customerPoELoad: poeLoadDetails,
          defaultPowerlimit: poeLoadDetails.powerlimit,
          isPoeLoadUpdated: true,
        });
      } else if (
        !poeLoadDetails &&
        customerPoELoad &&
        customerPoELoad !== this.props.customerPoELoad
      ) {
        this.setState({
          customerPoELoad,
          defaultPowerlimit: customerPoELoad.powerlimit,
        });
      }
    } else {
      if (customerPoELoad !== this.props.customerPoELoad) {
        this.setState({
          customerPoELoad,
          defaultPowerlimit: customerPoELoad.powerlimit,
        });
      }
    }
  }

  render() {
    const {
      translate,
      classes,
      isTestEdit,
      poeLoadDetails,
      testEdit,
      modified,
    } = this.props;
    const { customerPoELoad, poeErrors, isChanged, isRestore } = this.state;
    return (
      <div style={{marginTop: isTestEdit ? "15px" : "215px"}}>
        {!isTestEdit && (
          <Title
            back={
              !isChanged && (
                <Back
                  link={"/subtestsettings"}
                  title={translate("general_sub_test_settings")}
                />
              )
            }
            backCheck={
              isChanged && (
                <BackCheck
                  toCheck={this.onBackClick}
                  title={translate("general_sub_test_settings")}
                />
              )
            }
            title={translate("general_sub_test_poeload")}
          />
        )}
        <Content translate={translate}>
          {customerPoELoad && (
            <Grid container spacing={1}>
              <Grid item xs={isTestEdit ? 0 : 4}></Grid>
              <Grid item xs={isTestEdit ? 12 : 4}>
                <div className={classes.poeWrapper}>
                  <div>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={
                            customerPoELoad ? customerPoELoad.poestd : false
                          }
                          onChange={(e) => this.onCheckboxChange(e)}
                          value="enableMarginValue"
                          color="primary"
                          name="poestandard"
                        />
                      }
                      label={
                        <Typography className={classes.checkboxLabel}>
                          {translate("subtest_poeload_poestd")}
                        </Typography>
                      }
                    />
                    {
                      <Typography
                        className={classes.poeSubesttext}
                        type="subtitle2"
                        color={customerPoELoad.poestd ? "inherit" : "secondary"}
                      >
                        <span className={classes.poeSubesttexta}>
                          {translate("poe_subtest_info")}
                        </span>
                        <span className={classes.poeSubesttexta}>
                          {translate("poe_standard_ieee_af")}
                        </span>
                        <span className={classes.poeSubesttexta}>
                          {translate("poe_standard_ieee_at")}
                        </span>
                        <span className={classes.poeSubesttexta}>
                          {translate("poe_standard_ieee_bt")}
                        </span>
                      </Typography>
                    }
                  </div>
                  <div>
                    {customerPoELoad.poestd ? (
                      <div>
                        <Typography
                          color="secondary"
                          style={{ width: 100 }}
                          type="body1"
                        >
                          {translate("subtest_poeload_powerlimit")}
                          <p style={{ width: 100 }}>IEEE 802.3</p>
                        </Typography>
                      </div>
                    ) : (
                      <TextField
                        className={classes.textFieldR}
                        //id = "standard-basic"
                        name="powerlimit"
                        label={translate("subtest_poeload_powerlimit")}
                        margin="normal"
                        error={poeErrors && poeErrors.powerlimit ? true : false}
                        value={customerPoELoad ? customerPoELoad.powerlimit : 0}
                        disabled={
                          customerPoELoad && !customerPoELoad.poestd
                            ? false
                            : true
                        }
                        helperText={
                          poeErrors && poeErrors.powerlimit
                            ? poeErrors.powerlimit
                            : null
                        }
                        onChange={this.onTextEdit}
                      />
                    )}
                  </div>
                  {!isTestEdit && (
                    <div>
                      <Button
                        className={classes.button}
                        disabled={!isChanged}
                        color="accent"
                        raised
                        mini
                        onClick={() => this.onPoELoadSave()}
                      >
                        {translate
                          ? translate("sub_set_ping_save_target")
                          : "Save"}
                      </Button>
                    </div>
                  )}
                </div>
                {!isTestEdit && (
                  <ConfirmDialog
                    open={this.state.showConfirmBack}
                    title={translate("sub_test_ping_delete_confirm_title", {
                      name: "PoE Load",
                    })}
                    contentText={translate("sub_test_go_back_confirm_text")}
                    //okText={translate("general_confirm")}
                    cancelText={translate("general_cancel")}
                    //onOk={this.onTargetConfirmDelete}
                    onCancel={this.hideBackConfirmModal}
                    yesText={translate("back_btn_yes")}
                    noText={translate("back_btn_no")}
                    backText={translate("back_btn_go_back")}
                    onYes={this.onBackYesClick}
                    onNo={this.onBackNoClick}
                    onBack={this.hideBackConfirmModal}
                  />
                )}
                {isTestEdit && (
                  <ConfirmDialog
                    open={this.state.showRestoreConfirm}
                    title={
                      testEdit
                        ? translate("test_edit_title")
                        : translate("test_add")
                    }
                    contentText={translate("restore_go_back_confirm_text")}
                    contentSecondaryText={translate(
                      "general_confirmation_help_2"
                    )}
                    okText={translate("general_confirm")}
                    cancelText={translate("general_cancel")}
                    onOk={this.onRestoreConfirm}
                    onCancel={this.hideRestoreConfirmModal}
                  />
                )}
                {isTestEdit && (
                  <ConfirmDialog
                    open={this.props.showTestCreationCancelConfirmation}
                    title={
                      testEdit
                        ? translate("test_edit_title")
                        : translate("test_add")
                    }
                    contentText={translate("st_test_go_back_confirm_text")}
                    contentSecondaryText={translate(
                      "general_confirmation_help_2"
                    )}
                    okText={translate("general_confirm")}
                    cancelText={translate("general_cancel")}
                    onOk={this.props.onTestCreationCancelConfirm}
                    onCancel={this.props.hideTestCreationCancelConfirm}
                  />
                )}
              </Grid>
              <Grid item xs={isTestEdit ? 0 : 4}></Grid>
            </Grid>
          )}
        </Content>
        {isTestEdit && customerPoELoad && (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ display: "inline-block", marginLeft: "20px" }}>
              {poeLoadDetails && !testEdit ? (
                <Button
                  className={classes.restoreButton}
                  disabled={isRestore}
                  color="primary"
                  onClick={() => this.onResetDetails()}
                >
                  <Icon> restore </Icon> {translate("restore_default_settings")}
                </Button>
              ) : testEdit && modified ? (
                <Button
                  className={classes.restoreButton}
                  disabled={isRestore}
                  color="primary"
                  onClick={() => this.onResetDetails()}
                >
                  <Icon> restore </Icon> {translate("restore_default_settings")}
                </Button>
              ) : null}
            </div>
            <div style={{ display: "inline-block", marginRight: "20px" }}>
              <Button
                disabled={!isChanged}
                color="accent"
                raised
                onClick={() => this.onPoELoadSave()}
              className={classes.saveTarget}
            >
             
                {translate("general_continue")}
              </Button>
            </div>
          </div>
        )}
      </div>
    );
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

}

export default withRouter(withStyles(styles)(PoELoad));
